import { useEffect } from 'react';
import config from '../../config';
import { zendeskKey } from '../constants';

export const useLiveChat = () => {
  const { brokerTheme } = config;
  const isGS = brokerTheme === 'GoldSilver';
  useEffect(() => {
    if (isGS) {
      const snippet = document.querySelector('.ze-snippet');
      if (!snippet) {
        // goldsilver Zendesk Widget script
        const script = document.createElement('script');
        script.id = 'ze-snippet';
        script.type = 'text/javascript';
        script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
        document.body.appendChild(script);
      }
    }
  }, [isGS]);

  const startLiveChat = () => {
    if (window.zE) {
      window.zE('messenger', 'open');
    }
  };

  return { startLiveChat };
};
